export default "__VITE_ASSET__CUc7N6QG__"